import { EFinancingProgram, EPaymentFrequency, EProvince } from '@if/core/types'
import { addBusinessDays, format } from '@if/core/date'
import { ComputeFundingDto } from '@src/types/ComputePersonalLoanFundingDto'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import { Constants, PersonalLoanCalculatorConstants } from '@src/types/Constants'

export const createCalculationData = (
  merchantId: string,
  amountRequested: number,
  paymentPlanId: string,
  term: number,
  creditRatingInterestRate: number,
): ComputeFundingDto => {
  const deliveryOn = format(new Date(), 'yyyy-MM-dd')
  const firstPaymentOn = format(
    addBusinessDays(deliveryOn, PersonalLoanCalculatorConstants.BUSINESS_DAYS_OFFSET),
    'yyyy-MM-dd',
  )

  return {
    merchantId,
    includeInsurance: false,
    hasCoapplicant: false,
    creditApplicationId: '',
    requestId: PersonalLoanCalculatorConstants.TEMP_REQUEST_ID,
    interestRate: creditRatingInterestRate,
    stateIso: EProvince.Quebec,
    amountRequested,
    paymentPlanId,
    paymentFrequency: EPaymentFrequency.Monthly,
    term,
    deliveryOn,
    firstPaymentOn,
  }
}

export const createCalculatorCreditApp = () =>
  ({
    financingProgramId: EFinancingProgram.Personal,
    amountRequested: 0,
    consentHardHit: false,
    correspondanceLanguageId: PersonalLoanCalculatorConstants.CORRESPONDENCE_LANGUAGE_ID,
  }) as Partial<CreditApplication>

export const createComputeMonthTermFrequency = (
  merchantId: string,
  paymentPlanId: string,
  creditRatingInterestRate: number,
  amountRequested: number,
) => {
  const deliveryOn = format(new Date(), 'yyyy-MM-dd')
  const firstPaymentOn = format(
    addBusinessDays(deliveryOn, PersonalLoanCalculatorConstants.BUSINESS_DAYS_OFFSET),
    'yyyy-MM-dd',
  )

  return {
    merchantId,
    paymentPlanId,
    interestRate: creditRatingInterestRate,
    hasCoapplicant: false,
    stateIso: EProvince.Quebec,
    paymentFrequency: EPaymentFrequency.Monthly,
    deliveryOn,
    firstPaymentOn,
    maxPmtAmount: PersonalLoanCalculatorConstants.MAX_PAYMENT_AMOUNT,
    amountRequested,
    includeInsurance: false,
    include84Months: (amountRequested ?? 0) >= Constants.LargeLoanAmount,
  }
}

export const shouldAutoSelectTerm = (
  term: number | undefined,
  paymentPlanId: string | undefined,
  previousPaymentPlanId: string | null,
): boolean => {
  const paymentPlanChanged = paymentPlanId && paymentPlanId !== previousPaymentPlanId
  return !term || !!paymentPlanChanged
}

export const getDeliveryAndFirstPaymentDates = () => {
  const deliveryOn = format(new Date(), 'yyyy-MM-dd')
  const firstPaymentOn = format(
    addBusinessDays(deliveryOn, PersonalLoanCalculatorConstants.BUSINESS_DAYS_OFFSET),
    'yyyy-MM-dd',
  )
  return { deliveryOn, firstPaymentOn }
}
